module.exports = __webpack_public_path__ + "img/diners.8e106439.png";